const storageKey = {
  troubleshootingPath: "troubleshootingPath",
};

export default storageKey;
